export default __webpack_public_path__ + "static/media/fishmarketButton.b64f6729.png";